package data.objects.views.directediting

import data.objects.views.tagManagement
import dev.fritz2.core.Store
import localization.TL
import twcomponents.twSimpleModalWithCloseHeader
import webcomponents.KeywordTagType

fun twTagManageModal(
    toggleShowModalStore: Store<Boolean>,
    // add parameter you need inside the modal here
) {
    twSimpleModalWithCloseHeader(
        title = TL.KeywordTags.MANAGE_TAGS,
        toggleStore = toggleShowModalStore,
        closeHandlers = listOfNotNull(),
    ) { closeModal, _, optionalCloseHandlers ->
        div(
            baseClass = "flex flex-col gap-3 w-full md:w-120 h-full max-h-full p-2 overflow-y-hidden",
            id = "objectTagManage-modal",
        ) {
            div("flex flex-col w-full h-full overflow-y-auto") {
                tagManagement(type = KeywordTagType.ObjectTag)
            }
        }
    }
}


